import type { FormikValues } from 'formik';

import { isValidPhoneNumber } from 'app/design-system/components/PhoneInput/phone-input-helpers';
import type { tFunction } from 'app/lang';

import dictionary from './InitialForm.dictionary.json';

type ValidateErrors = {
  phoneNumber?: string;
  email?: string;
  newPass?: string;
  confirmPass?: string;
};
export const getValidate = (t: tFunction) => {
  return (values: FormikValues): ValidateErrors => {
    const errors: ValidateErrors = {};
    const { name, phoneNumber } = values;

    if (name === 'phoneNumber' && !isValidPhoneNumber(phoneNumber)) {
      errors.phoneNumber = t(dictionary.invalidPhoneNumber);
    }
    return errors;
  };
};
